import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import $ from 'jquery';
import moment from 'moment';
import {BrowserRouter} from "react-router-dom";
import {persistor, store} from './config/configureStore';
import {PersistGate} from 'redux-persist/lib/integration/react';
import {Provider} from "react-redux";

window.jQuery = $;
window.$ = $;
window.moment = moment;

ReactDOM.render(
    <BrowserRouter>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App/>
            </PersistGate>
        </Provider>
    </BrowserRouter> ,
    document.getElementById('root'));
reportWebVitals();
